import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';
import classnames from 'classnames';

import styles from './styles.module.css';

type KeepDriverModalProps = {
  close: () => void;
  driverLabel: string;
  isSubmiting: boolean;
};

export const KeepDriverModal: FC<KeepDriverModalProps> = ({
  close,
  driverLabel,
  isSubmiting,
}) => {
  return (
    <div
      data-testid="keep-driver-modal-container"
      className={classnames('fs-mask', styles.keepDriverContainer)}
    >
      <h1 className={styles.heading}>
        {driverLabel} Cannot be removed from the policy.
      </h1>
      <p className={styles.body}>
        Based on your answer to these questions, {driverLabel} needs to remain
        on the policy. You will have to enter license info.
      </p>
      <br />
      <p className={styles.body}>
        If you have any questions, please contact a Clearcover Coverage
        Consultant at 312-667-2957.
      </p>
      <div className={styles.buttonContainer}>
        <Button
          block
          data-testid="keep-driver-modal-button"
          variant="secondary"
          size="md"
          onClick={close}
          disabled={isSubmiting}
        >
          Keep Driver
        </Button>
      </div>
    </div>
  );
};
